import { useModuleContext } from "@cognitranlimited/itis-web";
export var vehicleSpecificationModuleId = Symbol("vehicleSpecificationModule");
export var useVehicleSpecificationContext = function () {
    return useModuleContext(vehicleSpecificationModuleId);
};
